const newApis = {
    // 开票明细
    '/v1/invoice-record/blue-retry-one': '/v3/invoice-operate/blue-retry-one', // 重试开单张蓝票
    '/v1/detail-record/red': '/v3/invoice-operate/red', // 冲红
    '/v1/detail-record/invalid': '/v3/invoice-operate/invalid', // 纸票作废
    '/v1/detail-record/list': '/v3/invoice-detail/list', // 明细列表
    '/v1/detail-record/info': '/v3/invoice-detail/info', // 详情
    '/v1/detail-record/send-mail': '/v3/detail-record/send-mail', //发送邮件
    '/v1/detail-record/print-paper-invoice': '/v3/paper/print', //打印功能
    '/v1/detail-record/out-list': '/v3/detail-record/out-list', //导出
};

export default newApis
